import axios from "axios";

export const OWNER_API = `${process.env.REACT_APP_BACKEND_URL}/api/owner`;

export const ownerApi = axios.create({
  baseURL: OWNER_API,
  withCredentials: true,
});

export function formatDetail(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
